import { styled, Tooltip } from '@ori-ui/mui';
import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';
import React from 'react';

import { maxWidth } from '../../constants';
import { useFooterContext } from '../../hooks';
import { extractChildrenWithNavigationType, updateImageUrl } from '../../utils';
import { extractFooterNavigationType } from '../../utils/extractFooterNavigationType';
import { MobileOfficeRoot } from '../MobileOffice';

const MobileOfficeRootSection = MobileOfficeRoot.withComponent('section');

const Root = styled(MobileOfficeRootSection)(({ theme }) => ({
  maxWidth,
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(0, 'auto', 6),
  padding: theme.spacing(0, 3),
}));

const Item = styled('img')(({ theme }) => ({
  margin: `0 ${theme.spacing(2)} ${theme.spacing(3)}`,
  height: theme.spacing(5),
}));

export const PaymentMethods: React.FC = () => {
  const { data, isMobileOffice } = useFooterContext();

  const footer = extractFooterNavigationType(data);

  const paymentMethods = extractChildrenWithNavigationType(
    StaticNavigationNavigationItemDtoLinkType.PaymentMethods,
    footer,
  );
  const paymentMethodsItems = paymentMethods?.children.filter(
    (x) => x.linkType === StaticNavigationNavigationItemDtoLinkType.PaymentMethod,
  );

  if (paymentMethodsItems?.length == null) {
    return null;
  }

  const jpgSettings = ['h=70', 'q=90'];

  return (
    <Root isMobileOffice={isMobileOffice}>
      {paymentMethodsItems.map((pm, index) => (
        <Tooltip
          key={pm.imageUrl ?? index}
          title={pm.title ?? ''}
          placement="top"
        >
          <Item
            src={updateImageUrl({ url: pm.imageUrl, passPNG: true, jpgSettings })}
            alt={pm.title ?? ''}
          />
        </Tooltip>
      ))}
    </Root>
  );
};
